import { create } from "zustand";

interface ContentManagerStoreState {
  documents: any[];
  setDocuments: (docs: any[]) => void;

  selectedDocumentId: string | null;
  setSelectedDocumentId: (id: string | null) => void;

  powerpointId: string | null;
  setPowerpointId: (id: string | null) => void;

  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;

  error: string | null;
  setError: (message: string | null) => void;
}

export const useContentManagerStore = create<ContentManagerStoreState>((set) => ({
  documents: [],
  setDocuments: (docs) => set({ documents: docs }),

  selectedDocumentId: null,
  setSelectedDocumentId: (id) => set({ selectedDocumentId: id }),

  powerpointId: null,
  setPowerpointId: (id) => set({ powerpointId: id }),

  isLoading: false,
  setIsLoading: (loading) => set({ isLoading: loading }),

  error: null,
  setError: (message) => set({ error: message }),
}));


